import type { DataTableColumn } from '@/components/custom/erp';
import type { LyDoTangGiamCCDC } from '@/types/schemas';

export const getToolEquipmentChangeReasonColumns = (
  onCodeClick?: (uuid: string) => void,
  onEditClick?: () => void
): DataTableColumn<LyDoTangGiamCCDC>[] => [
  {
    field: 'loai_tg_cc',
    headerName: 'Loại tăng giảm',
    width: 200,
    renderCell: params => {
      const value = params.value;
      if (value === undefined || value === null) return '';
      return <div>{value === '1' ? '1. Tăng' : '2. Giảm'}</div>;
    }
  },
  {
    field: 'ma_tg_cc',
    headerName: 'Mã tăng giảm',
    width: 150,
    renderCell: params => (
      <div
        className='cursor-pointer text-main hover:underline'
        onClick={e => {
          onCodeClick?.(params.row.uuid);
          e.stopPropagation();
        }}
      >
        {String(params.value ?? '')}
      </div>
    )
  },
  { field: 'ten_tg_cc', headerName: 'Tên tăng giảm', width: 200 }
];

export const toolEquipmentChangeReasonDetailColumns: DataTableColumn<LyDoTangGiamCCDC>[] = [
  {
    field: 'loai_tg_cc',
    headerName: 'Loại tăng giảm',
    width: 150,
    renderCell: params => {
      const value = params.value;
      if (value === undefined || value === null) return '';
      return <div>{value === '1' ? '1. Tăng' : '2. Giảm'}</div>;
    }
  },
  { field: 'ma_tg_cc', headerName: 'Mã tăng giảm', width: 100 },
  { field: 'ten_tg_cc', headerName: 'Tên tăng giảm', width: 200 },
  { field: 'ten_tg_cc2', headerName: 'Tên khác', width: 200 },
  {
    field: 'status',
    headerName: 'Trạng thái',
    width: 150,
    renderCell: params => {
      const value = params.value;
      if (value === undefined || value === null) return '';
      return <div>{value === '1' ? '1. Còn sử dụng' : '0. Không sử dụng'}</div>;
    }
  }
];
